/* HOTWEARS - front-end behaviour
   Vanilla, dependency-free, safe to load deferred. Every feature degrades:
   if this file fails to run the page is still fully readable and shoppable. */

(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------- scroll reveals */

  function initReveals(root) {
    var nodes = (root || document).querySelectorAll('.hw-reveal:not([data-observed])');
    if (!nodes.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) {
        n.classList.add('is-in');
        n.setAttribute('data-observed', '');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    nodes.forEach(function (n) {
      n.setAttribute('data-observed', '');
      io.observe(n);
    });
  }

  /* ------------------------------------------------------------ hero slider */

  function initHero(section) {
    var slides = section.querySelectorAll('.hw-hero__slide');
    var dots = section.querySelectorAll('.hw-hero__dot');
    if (slides.length < 2) return;

    var index = 0;
    var timer = null;
    var delay = parseInt(section.dataset.autoplaySpeed, 10) * 1000 || 6000;
    var autoplay = section.dataset.autoplay === 'true' && !reduceMotion;

    function go(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        if (i === index) s.setAttribute('data-active', '');
        else s.removeAttribute('data-active');
      });
      dots.forEach(function (d, i) {
        d.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    function start() {
      if (!autoplay) return;
      stop();
      timer = setInterval(function () { go(index + 1); }, delay);
    }

    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { go(i); start(); });
    });

    // Pause while hovered or while the tab is hidden - no wasted work.
    section.addEventListener('mouseenter', stop);
    section.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    // Touch swipe
    var startX = null;
    section.addEventListener('touchstart', function (e) {
      startX = e.changedTouches[0].clientX;
      stop();
    }, { passive: true });

    section.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 45) go(index + (dx < 0 ? 1 : -1));
      startX = null;
      start();
    }, { passive: true });

    go(0);
    start();
  }

  /* --------------------------------------------------------------- marquee */

  function initMarquee(section) {
    var track = section.querySelector('.hw-marquee__track');
    if (!track || track.dataset.cloned === 'true') return;
    // Duplicate the content once so the -50% keyframe loops seamlessly.
    track.innerHTML += track.innerHTML;
    track.dataset.cloned = 'true';
  }

  /* -------------------------------------------------------- newsletter form */

  function initNewsletter(section) {
    // Shopify posts the form and returns with ?customer_posted=true.
    // Nothing to intercept - this only moves focus for a11y after a success.
    var success = section.querySelector('[data-hw-news-success]');
    if (success) success.setAttribute('tabindex', '-1');
  }

  /* ------------------------------------------------------- lookbook carousel */

  function initLookbook(section) {
    var track = section.querySelector('[data-hw-lb-track]');
    var prev = section.querySelector('[data-hw-lb-prev]');
    var next = section.querySelector('[data-hw-lb-next]');
    if (!track) return;

    function step() {
      var cell = track.querySelector('.hw-lb__cell');
      if (!cell) return track.clientWidth * 0.8;
      var style = getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || '10') || 10;
      return cell.getBoundingClientRect().width + gap;
    }

    function updateArrows() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    });

    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  /* ------------------------------------------------------------- bootstrap */

  function boot(scope) {
    var root = scope || document;
    initReveals(root);
    root.querySelectorAll('[data-hw-hero]').forEach(initHero);
    root.querySelectorAll('[data-hw-marquee]').forEach(initMarquee);
    root.querySelectorAll('[data-hw-newsletter]').forEach(initNewsletter);
    root.querySelectorAll('[data-hw-lookbook]').forEach(initLookbook);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  // Theme editor: re-initialise a section when the merchant edits it, so the
  // preview never shows a dead slider or an un-revealed block.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });
})();
